export const WIZARD_STEPS = Object.freeze({
  ERROR: 'error',
  EMAIL_ENTER: 'emailEnter',
  EMAIL_SENT: 'emailSent',
  FEEDBACK: 'feedback',
  FREEZED: 'freezed',
  HAPPY: 'happy',
  KEEP_IN_MIND: 'keepInMind',
  REASON: 'reason',
  SAD: 'sad',
  SPECIAL_OFFER: 'specialOffer',
  TO_PAUSE: 'toPause',
  LOTS_OF_NEW: 'lotsOfNew',
  KEEP_PREMIUM: 'keepPremium',
  LIFETIME_ACCESS: 'lifetimeAccess',
  GIFT_PREMIUM: 'giftPremium',
  PREMIUM_ACTIVATED: 'premiumActivated',
  DISCOUNT_ACTIVATED: 'discountActivated',
  SPECIAL_DISCOUNT: 'specialDiscount',
  LIFETIME_ACTIVATED: 'lifetimeActivated',
});

export const WEB_UNSUBSCRIBE_PATHS = [
  WIZARD_STEPS.REASON,
  {
    '1': [
      WIZARD_STEPS.KEEP_IN_MIND,
      {
        '1.1': WIZARD_STEPS.HAPPY,
        '1.2': WIZARD_STEPS.SAD,
      },
    ],
    '2': [
      WIZARD_STEPS.KEEP_IN_MIND,
      {
        '1.1': WIZARD_STEPS.HAPPY,
        '1.2': WIZARD_STEPS.SAD,
      },
    ],
    '3': [WIZARD_STEPS.FEEDBACK, WIZARD_STEPS.KEEP_IN_MIND],
    '4': [WIZARD_STEPS.FEEDBACK, WIZARD_STEPS.TO_PAUSE],
  },
];

export const MANAGE_SUBSCRIPTION_PATHS = [
  WIZARD_STEPS.EMAIL_ENTER,
  WIZARD_STEPS.EMAIL_SENT,
];
